<template>

        <conteudo :ajax="false">

                <race-selector>
                </race-selector>

                <!-- <div class="navegationTrechos">
                        <a class='prev' @click="prev()"> <i class='fa fa-arrow-left'></i> </a>
                        <a class='next' @click="next()"> <i class='fa fa-arrow-right'></i> </a>
                </div> -->
              
                <transition name="slide" appear>
                     <div  class='trecho-info mt-2'> 
                       <trecho-info :trecho="currentCheckpoint"></trecho-info>
                    </div> 
                </transition>

                  
           
                

        </conteudo>

</template>


<script>
    import Conteudo from './conteudo.vue'
    // import marked from 'marked'

    export default {
        data(){
            return {
                mudando:false
            }
        },

        components: {
            'conteudo':Conteudo
        },

        computed:{
            checkpoints:function(){
                return this.$store.getters.checkpoints;
            },
            
            currentRace:function(){
                return this.$store.getters.currentRace;
            },

            currentRaceName:function(){
                return this.$store.getters.currentRaceName;
            },

            currentCheckpoint:function(){
                return this.checkpoints[_.get(this.$route,'params.id',0)];
            }
        },


        beforeDestroy:function(){
            this.$store.commit('actualCourseLeg',false)
        },

        // beforeCreate () {
        //     var id = _.get(this.$route,'params.id',0);
        //     this.$router.push( {params: { id: id }} )
        //     this.$store.commit('trechoIndex',id);  
            
        //     //se ja existir mostro o trecho
        //     if( _.has(vtl,'mapBase.percurso') ){
        //             vtl.mapBase.percurso.showTrecho(id);
        //     }else{
        //         //senao quando carregar mostro o trecho
        //         vtl.mapBase.on('trechosGenerated',()=>{
        //             vtl.mapBase.percurso.showTrecho(id);
        //         })
        //     }
        // },

        // beforeDestroy () {
        //     vtl.mapBase.percurso.hideTrecho();
        // },

        created:function(){
            
                    var id = parseInt(_.get(this.$route,'params.id',0),10);
                    var raceIndex = _.get(this.$route,'params.race',false);
                    
                    if(raceIndex){
                          this.$store.commit('setPercursoState',{actualRace:parseInt(raceIndex)});
                    }
                    this.$store.commit('actualCourseLeg',id);

                     this.$store.commit('altimetriaVisible',true);

                    // setTimeout(()=>{
                    //     this.$watch('currentRace', () => {
                    //             this.$router.push( {params: { id: 0, race: this.currentRace.id }} )
                    //     });



                    // },400)

                    $("body").keydown((e)=> {
                            if(e.keyCode == 37) { // left
                               this.prev()
                            }
                            else if(e.keyCode == 39) { // right
                              this.next()
                            }
                    });
        },

        mounted:function(){
                debugger
                       
                // Verifica se o router não tem id e race, se não tiver, faz o push
                if (!this.$route.params.id && !this.$route.params.race) {
                    // var id = parseInt(_.get(this.$route,'params.id',0),10);
                    // var raceIndex = _.get(this.$route,'params.race',0);
                    this.$router.push({ params: { id: 0, race: 0 } });
                }
        },


        watch:{
            '$route':function(to,from){
                    debugger
                    var id = parseInt(_.get(to,'params.id',0),10);
                    var raceIndex = _.get(this.$route,'params.race',false);
                    if(raceIndex){
                          this.$store.commit('setPercursoState',{actualRace:raceIndex});
                    }
                    this.$store.commit('actualCourseLeg',id);
            },
            //set after created
            // currentRace:function(){
            //     this.$router.push( {params: { id: 0, race: this.currentRace.id }} )
            // },
        },

        // computed:{
        //     trechos: function(){
        //          return this.$store.getters.trechos
        //     },
        //     trechoIndex: function(){
        //          return this.$store.getters.trechoIndex
        //     },

        //     trecho: function(){
        //         return this.trechos[this.trechoIndex]
        //     }

        // },

        methods:{

        //     parseMarkedown:function(text){
        //         return marked(text,{breaks:true})
        //     },

            prev:function(){
                var actualIndex = _.get(this.$route,'params.id',0);
                actualIndex--
                if( actualIndex < 0 ){
                    actualIndex = this.checkpoints.length-1
                }
                this.$router.push( {params: { id: actualIndex }} )
            },

            next:function(){
                var actualIndex = _.get(this.$route,'params.id',0);
                actualIndex++
                if( actualIndex > this.checkpoints.length-1 ){
                    actualIndex = 0
                }
                this.$router.push( {params: { id: actualIndex }} )
            },
        }


    }
    
</script>



<style lang="stylus">
    @import "./../css/variaveis"

    .trecho-info{

        .descripition{
            b,strong{
                color lighten(color-orange,40%)
            }
        }

    }
       
        .slide-enter-to, .slide-leave{ 
               transform: translateX(10px);
               opacity: 0.5;
                transition: all .6s ease;
        }
         .slide-enter, .slide-leave-to{
               transform: translateX(10px);
               opacity: 0;
               transition: all .6s ease;
        }


    .navegationTrechos{
        text-align right;
        // position:absolute;
        margin-top:1em;
        left:1em;
        user-select: none;
        a{
            cursor: pointer;
            display:inline-block;
            background rgba(black,0.5);
            padding:8px;
            border-radius 50%;
            font-size:1.2em;
            margin-top:-0.5em;

        }
        
    }

</style>